<div class='blog__container' *ngIf="!empty" (click)="goToBlog(blog.id, blog.title)">
  <ng-container>
    <img alt=''
         class='swiper-lazy'
         data-src="{{baseUrl + '/web/api/blog/image/' + blog.img}}" loading='lazy'>
    <div class="blog-info">
      <div class="blog-title blog-title-class">{{blog.title}}</div>
      <div [innerHTML]="blog.shortDescription" class="blog-short-desc" [class.showEllipsis]="showEllipsis"></div>
    </div>
    <div class="blog-action">
      <!-- <span>{{'learn-more' | translate}}</span>
      <button>
        <mat-icon>
          keyboard_arrow_right
        </mat-icon>
      </button> -->
    </div>
  </ng-container>

</div>
<div class='blog__container' *ngIf="empty">
  <ng-container>
    <div class="see-all-blogs">
      <div class="see-all-blogs__title">{{'find-out-more-information' | translate}}</div>
      <span class=" truncate-text">{{'a-small-description-of-what-type-of-information-a-blog-can-contain' | translate}}</span>
      <button class="uppercase" matRipple routerLink="/blog-list">{{'see-all' | translate}}</button>
    </div>
  </ng-container>
</div>
